// Auto-generated from old repo translations - do not edit by hand
const zh: Record<string, string> = {
  'site.title': '创益编程 - 用简易积木玩转新科技',
  'site.meta.description': '用简易积木玩转新科技 | 免费游乐场和教程',
  'site.meta.keywords':
    '教程, 免费游乐场, 3D 模型, 3D 编程, 3D 游戏, 创造力, 游戏, 编码, 问题解决, 设计思维, 3D models, 3D programming, 3D Games, Metaverse, Creativity, 3D, Game, Coding, Problem Solving, Design Thinking',
  'site.meta.og:title': '创益编程 - 用简易积木玩转新科技 | 免费游乐场和教程',
  'logo.white': 'newlogo200.png',
  'logo.whiteLarge': 'newlogo400.png',
  'logo.green': 'creaticodeword_zhcn_300.png',
  'logo.greenLarge': 'creaticodeword_zhcn_600.png',
  'logo.logo': 'cn-logo.png',
  'WhyBanner.mainTitle': '为什么要选择创益编程?',
  'WhyBanner.creativeTitle': '基于通用的图形化编程语言',
  'WhyBanner.creativeContent':
    '我们的平台基于世界通用的青少年编程积木语言,保持了简单易用的编程界面和语法,并添加了不少提高编程效率的新功能。',
  'WhyBanner.contactTitle': '简化的三维编程语言',
  'WhyBanner.contactContent':
    '我们精心设计了一套简单易懂的三维编程积木组合,让你不再需要另外学习晦涩的编程语法和复杂的用户界面,而只需专心学习3D相关的技术。',
  'WhyBanner.focusTitle': '自定进度课程',
  'WhyBanner.focusContent': '我们的课程包含许多渐进的微知识点和有针对性的练习项目,让你按照自己的时间安排和偏好规划学习路径和进度。',
  'WhyBanner2.mainTitle': '为什么要学习3D编程?',
  'WhyBanner2.creativeTitle': '超级趣味体验',
  'WhyBanner2.creativeContent':
    '写3D项目就像玩游戏一样有趣: 无限大的虚拟世界,可随意控制的摄像头,逼真的物体和人物造型,自然的交互体验,都会帮你做出让人惊叹的作品。',
  'WhyBanner2.contactTitle': '全方位大脑训练',
  'WhyBanner2.contactContent':
    '搭建3D项目可以同时开发你的左脑（数学计算和逻辑分析）和右脑（项目设计的创造力和审美能力,以及立体空间想象能力）。',
  'WhyBanner2.focusTitle': '面向未来科技',
  'WhyBanner2.focusContent': '3D编程是解锁许多令人兴奋的未来技术的关键技能,例如元宇宙（VR/AR）、计算机辅助设计（CAD）和3D打印。',
  'WhyBanner3.mainTitle': '为什么学习人工智能?',
  'WhyBanner3.creativeTitle': '无限的学习机会',
  'WhyBanner3.creativeContent': '人工智能打开了广阔的学习空间。从基础概念到高级技术,学生都可以在这个快速发展的领域中不断提升自己的能力。',
  'WhyBanner3.contactTitle': '培养未来创新者',
  'WhyBanner3.contactContent': '学习人工智能能让学生掌握创新工具,帮助他们解决现实世界中的问题,并推动技术进步。',
  'WhyBanner3.focusTitle': '理解伦理挑战',
  'WhyBanner3.focusContent': '学习人工智能可以帮助学生理解偏见、隐私等伦理议题,也能消除对人工智能取代人类的误解,更清楚地认识它的真实能力。',
  'VideoBannerTop.sectionTitle': '观看创益编程演示',
  'VideoBannerTop.creativeTitle': '增强的 2D\nScratch 游乐场',
  'VideoBannerTop.contactTitle': '3D Scratch\n游乐场',
  'VideoBannerTop.focusTitle': '自定进度\n课程',
  'VideoBannerTop.creative.title': '增强的 2D\nScratch 游乐场',
  'VideoBannerTop.creative.mediaLink': 'https://videos.creaticode.com/enhanced-2d-scratch-playground.mp4',
  'VideoBannerTop.contact.title': '3D Scratch\n游乐场',
  'VideoBannerTop.contact.mediaLink': 'https://videos.creaticode.com/3d-scratch-playground.mp4',
  'VideoBannerTop.focus.title': '自定进度\n课程',
  'VideoBannerTop.focus.mediaLink': 'https://videos.creaticode.com/self-paced-curriculum.mp4',
  'VideoBannerTop.creativeCN.title': '用图形化积木写三维程序',
  'VideoBannerTop.creativeCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'TopBanner.creaticode': '创益编程',
  'TopBanner.Header': '创益编程 - 用简易积木玩转新科技',
  'TopBanner.BriefIntroduction.0': 'AI 工具',
  'TopBanner.BriefIntroduction.1': '编程与设计',
  'TopBanner.BriefIntroduction.2': 'AI + 3D 项目',
  'TopBanner.SignUpButton': '免费注册',
  'TopBanner.menu': '菜单',
  'TopBanner.NavBarButtons.games': '游戏',
  'TopBanner.NavBarButtons.courses': '教程',
  'TopBanner.NavBarButtons.dashboard': '个人中心',
  'TopBanner.NavBarButtons.myStuff': '我的东西',
  'TopBanner.NavBarButtons.leaderBoard': '排行榜',
  'TopBanner.NavBarButtons.forum': '论坛',
  'TopBanner.NavBarButtons.about': '关于我们',
  'TopBanner.NavBarButtons.contact': '联系我们',
  'TopBanner.NavBarButtons.create': '创建',
  'TopBanner.NavBarButtons.joinNow': '免费注册',
  'TopBanner.NavBarButtons.logout': '登出',
  'TopBanner.NavBarButtons.signIn': '登录',
  'TopBanner.NavBarButtons.explore': '发现',
  'TopBanner.NavBarButtons.olympic': '奥林匹克',
  'TopBanner.NavBarButtons.learn': '学习',
  'TopBanner.NavBarButtons.hourOfCode': '教程',
  'TopBanner.guideLine': '驾驶: W/S/A/D 键\n刹车/翻身: 空格键',
  'TopBanner.signIn': '登录',
  'TopBanner.join': '加入',
  'TopBanner.myStuff': '我的东西',
  'TopBanner.slogan': '创益编程：用简易积木玩转新科技',
  'TopBanner.subtitle': '让 AI 与 3D 编程变得简单、有创意又有趣。',
  'TopBanner.whatBody':
    '创益编程基于 Scratch 3.0，并加入适合学生使用的 AI 与 3D 工具。学生可以生成图片、获得编程辅助，并使用 AI 分类下的积木，为项目加入视觉识别、语音、聊天等智能功能。\n\n通过引导式课程和创意游乐场，学生无需学习复杂语言，也能把想法做成 AI 驱动的作品。',
  'Footer.Title.highlight': '强调',
  'Footer.Title.contact': '联系我们',
  'Footer.Title.community': '社区',
  'Footer.Title.connect': '保持联系',
  'Footer.Title.linkWithSocial': '绑定社交账号',
  'Footer.Highlight.about-us': '关于我们',
  'Footer.Highlight.contact': '联系我们',
  'Footer.Highlight.create': '创建',
  'Footer.Highlight.explore': '发现',
  'Footer.Highlight.founder-story': '创始人故事',
  'Footer.Highlight.advisor-team': '顾问团队',
  'Footer.Highlight.join-us': '加入我们',
  'Footer.Highlight.forum': '论坛',
  'Footer.Highlight.privacy-policy': '隐私政策',
  'Footer.Highlight.tutorials': '教程',
  'Footer.CopyRight': '版权所有',
  'Footer.Title.mission': '使命',
  'Footer.mission': '让每一位学习者都能运用 AI 创造、解决问题，并将想法变为现实。',
  'DashBoardHeader.NavBarButtons.dashboard': '个人中心',
  'DashBoardHeader.NavBarButtons.games': '游戏',
  'DashBoardHeader.NavBarButtons.courses': '教程',
  'DashBoardHeader.NavBarButtons.leaderBoard': '排行榜',
  'DashBoardHeader.NavBarButtons.forum': '论坛',
  'DashBoardHeader.NavBarButtons.about': '关于我们',
  'DashBoardHeader.NavBarButtons.contact': '联系我们',
  'DashBoardHeader.NavBarButtons.create': '创建',
  'DashBoardHeader.NavBarButtons.joinNow': '免费注册',
  'DashBoardHeader.NavBarButtons.logout': '登出',
  'DashBoardHeader.NavBarButtons.admin': '管理员',
  'DashBoardHeader.NavBarButtons.signIn': '登录',
  'DashBoardHeader.NavBarButtons.teacher': '老师',
  'DashBoardHeader.NavBarButtons.school': '学校',
  'DashBoardHeader.NavBarButtons.migration': '移民',
  'DashBoardHeader.NavBarButtons.explore': '发现',
  'DashBoardHeader.NavBarButtons.olympic': '奥林匹克',
  'DashBoardHeader.NavBarButtons.learn': '学习',
  'DashBoardHeader.NavBarButtons.hourOfCode': '教程',
  'DashBoardHeader.NavBarButtons.metrics': '指标',
  'DashBoardHeader.NavBarButtons.setting': '环境',
  'DashBoardHeader.NavBarButtons.discounts': '折扣',
  'DashBoardHeader.NavBarButtons.support': '支持',
  'UpperFooter.title': '从今天开始学习',
  'UpperFooter.subTitle': '为将来的人工智能时代做好准备',
  'UpperFooter.joinButton': '试试看',
  'ExampleProjects.title': '示例项目',
  'ExampleProjects.slides.rover.title': '火星探测器',
  'ExampleProjects.slides.rover.content': '一个可以在火星表面展开、移动和转动的漫游车。',
  'ExampleProjects.slides.rover.image': 'marsdemo1_600.gif',
  'ExampleProjects.slides.solar.title': '太阳系',
  'ExampleProjects.slides.solar.content': '模拟太阳系内行星的公转和自转。',
  'ExampleProjects.slides.solar.image': 'solar.gif',
  'ExampleProjects.slides.d3maze.title': '迷宫游戏',
  'ExampleProjects.slides.d3maze.content': '驾驶汽车走出迷宫般的墙壁。',
  'ExampleProjects.slides.d3maze.image': '3dmazedemo.gif',
  'ExampleProjects.slides.d3walkway.title': '悬浮走道',
  'ExampleProjects.slides.d3walkway.content': '由3块飞砖组成的悬浮走道。',
  'ExampleProjects.slides.d3walkway.image': '3dwalkway.gif',
  'ExampleProjects.slides.magellan.title': '麦哲伦环球航线',
  'ExampleProjects.slides.magellan.content': '3D再现麦哲伦的船队如何环绕地球',
  'ExampleProjects.slides.magellan.image': 'm2.gif',
  'ExampleProjects.slides.boymirror.title': '动画人物',
  'ExampleProjects.slides.boymirror.content': '一个男孩儿站在一块巨大的镜子上玩儿。',
  'ExampleProjects.slides.boymirror.image': 'boy3.gif',
  'ExampleProjects.slides.d3bus.title': '漂亮的巴士',
  'ExampleProjects.slides.d3bus.content': '完整的巴士模型,带有轮子、窗户、门和灯。',
  'ExampleProjects.slides.d3bus.image': 'busdemo.gif',
  'ExampleProjects.slides.ai.title': 'AI游戏玩家',
  'ExampleProjects.slides.ai.content': '学习手动玩游戏,然后按照教程来构建自动玩游戏的游戏机器人。',
  'ExampleProjects.slides.ai.image': 'MonkeyGame.gif',
  'ExampleProjects.slides.drawing.title': '绘图几何',
  'ExampleProjects.slides.drawing.content': '在学习画图的游戏中掌握编程技能和几何知识。',
  'ExampleProjects.slides.drawing.image': 'castle1.gif',
  'ExampleProjects.slides.algorithms.title': '经典算法',
  'ExampleProjects.slides.algorithms.content': '通过动手游戏和可视化模拟轻松掌握经典算法（排序、搜索等等）。',
  'ExampleProjects.slides.algorithms.image': 'FootBallGame.gif',
  'ExampleProjects.slides.simulate.title': '模拟真实AI应用',
  'ExampleProjects.slides.simulate.content': '编程模拟真实世界中的各类人工智能应用。',
  'ExampleProjects.slides.simulate.image': 'PandaGame.gif',
  'ExampleProjects.slides.introducing.title': '人工智能算法',
  'ExampleProjects.slides.introducing.content': '编程完成各类人工智能算法,了解算法背后的道理',
  'ExampleProjects.slides.introducing.image': 'NumberDrawingGame.gif',
  changeLanguage: '切换语言',
};

export default zh;
